export const BUSINESS = {
  legalName: "BrightHarbor",
  tradingAs: "Your Life Journeys Matter",
  email: "support@yourlifejourneysmatter.com",
};

export const REFUND_POLICY = [
  {
    h: "Lifetime Access — change of mind",
    p: "You may request a change of mind refund within 14 days of purchasing Lifetime Access, provided you have not started using any paid Life Season or paid feature.",
  },
  {
    h: "Memory Insight, Yearly Reflection, Whole Life Reflection and Ebook",
    p: "You may request a refund within 14 days of purchasing a Memory Insight (Personal Memory Insight), Yearly Reflection, Whole Life (Lifetime) Reflection or My Life Story Ebook if the product has not yet been generated or downloaded.",
  },
  {
    h: "Lifetime Access gifts",
    p: "You may request a change of mind refund within 14 days of purchasing a Lifetime Access gift, provided the gift code has not been redeemed. Once a code is redeemed, the gift belongs to the recipient.",
  },
  {
    h: "If an AI product has a problem",
    p: "If an AI product fails to generate, is incomplete or has a serious technical problem, we will first offer to generate it again at no additional cost. If the problem cannot be corrected within a reasonable time, you may receive a refund.",
  },
  {
    h: "Accidental duplicate payments",
    p: "Accidental duplicate payments will be refunded.",
  },
  {
    h: "How to request a refund",
    p: `Email ${"support@yourlifejourneysmatter.com"} with your username, the payment date and the transaction reference shown on your receipt. Never send us your password or your full card details.`,
  },
  {
    h: "How refunds are paid",
    p: "Approved refunds are returned through the original payment method (card via Stripe, or PayPal). Processing time may depend on Stripe, PayPal or your bank.",
  },
  {
    h: "Your rights under Australian Consumer Law",
    p: "This policy does not limit any rights you have under the Australian Consumer Law. You are generally not entitled to a refund simply because you changed your mind, but your rights remain if a product or service has a genuine problem.",
  },
];

export const PRIVACY_POLICY = [
  {
    h: "What we collect",
    p: "To create an account we ask only for your first name, a username, a password and your email address. Your email is used only for account recovery, receipts and important account notices (such as trial reminders, which you can unsubscribe from). We never ask for your phone number or home address. Your password is stored securely hashed — we can never see it.",
  },
  {
    h: "Your memories",
    p: "Your memories are private. We never share or sell them, and only you can see your diary. They are stored securely so you can read them, download them and use them for optional products you choose to buy.",
  },
  {
    h: "Photos",
    p: "Photos for the My Life Story Ebook are chosen, cropped and placed entirely inside your own browser. They are never uploaded to or stored on our server. The finished Ebook PDF is created on your device. Location data inside photos is removed before they are added to your book.",
  },
  {
    h: "AI-written products",
    p: "Memory Insights, Reflections and the Ebook text are written by an AI service (Anthropic Claude) called securely from our server. We send only the memories needed for the product you choose, and only after you tick a consent box. The AI is instructed to use only your memories and never invent facts. AI processing may take place on cloud infrastructure outside Australia (United States and India).",
  },
  {
    h: "Payments",
    p: "Payments are processed by Stripe (cards) and PayPal. We never see or store your full card details. We keep a record of each payment (date, product, amount and payment reference) because Australian tax law requires us to keep it for 5 years; these records never contain your memories.",
  },
  {
    h: "How long we keep your information",
    p: "If you don't join after your 10-day free trial, your diary is paused for 30 days — you can still sign in to read, download or delete it — and then it is permanently deleted. You can download or delete your account yourself at any time using the \u201cYour data\u201d button in your diary.",
  },
  {
    h: "Your rights",
    p: "You can ask us to access, correct or delete your personal information at any time by emailing support@yourlifejourneysmatter.com. We handle personal information in line with the Australian Privacy Principles. Please never send your password or full card details by email.",
  },
];
